import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { SystemProps } from '@sternum/styled-system';
import { SpinnerIcon } from '@sternum/web/icons';

import {
  ContainerWithFixedLoadingStyled,
  ContentContainer,
  SpinnerContainer,
} from './ContainerWithFixedLoading.styles';

export interface ContainerWithFixedLoadingRenderContentArgs {
  Component: typeof ContentContainer;
  props: { isVisible: boolean; children: ReactNode };
}

export interface ContainerWithFixedLoadingProps extends ComponentPropsWithoutRef<'div'>, Omit<SystemProps, 'color'> {
  isLoading?: boolean;
  spinnerIcon?: ReactNode;
  spinnerSize?: number;
  renderContentContainer?: (args: ContainerWithFixedLoadingRenderContentArgs) => ReactNode;
}

export function ContainerWithFixedLoading({
  isLoading,
  spinnerSize = 45,
  spinnerIcon = <SpinnerIcon width={spinnerSize} height={spinnerSize} />,
  renderContentContainer,
  children,
  ...props
}: ContainerWithFixedLoadingProps) {
  const renderContentContainerLocal =
    renderContentContainer ??
    (({ Component, props }: ContainerWithFixedLoadingRenderContentArgs) => {
      return <Component {...props} />;
    });

  return (
    <ContainerWithFixedLoadingStyled {...props}>
      {isLoading && (
        <SpinnerContainer role="region" aria-label="loading spinner">
          {spinnerIcon}
        </SpinnerContainer>
      )}
      {renderContentContainerLocal({ Component: ContentContainer, props: { isVisible: !isLoading, children } })}
    </ContainerWithFixedLoadingStyled>
  );
}

ContainerWithFixedLoading.ContentContainer = ContentContainer;
